import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";
import { Cpu, Target, Wrench, Layers, Users, Handshake } from "lucide-react";

const icons = [Cpu, Target, Wrench, Layers, Users, Handshake];

const ABOUT_IMG = "https://images.unsplash.com/photo-1679347908031-ba46585cf9ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkYXJrJTIwdGVjaCUyMG9mZmljZSUyMGVtcHR5fGVufDB8fHx8MTc3NjI3MDEyNXww&ixlib=rb-4.1.0&q=85";

export default function WhyUs() {
  const { t } = useLanguage();
  const points = t("whyUs.points");

  return (
    <section data-testid="why-us-section" className="relative py-24 md:py-32 lg:py-48 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="font-mono text-xs tracking-[0.25em] text-[#00F0FF] mb-4 block">
              {t("whyUs.overline")}
            </span>
            <h2 className="font-outfit font-bold text-4xl md:text-5xl leading-tight tracking-tighter text-white mb-4">
              {t("whyUs.title")}
            </h2>
            <p className="text-lg text-neutral-400 font-manrope mb-12 max-w-lg">
              {t("whyUs.subtitle")}
            </p>

            <div className="space-y-8">
              {Array.isArray(points) && points.map((point, i) => {
                const Icon = icons[i] || Cpu;
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -15 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    className="flex gap-4"
                    data-testid={`why-us-point-${i}`}
                  >
                    <Icon className="w-5 h-5 text-[#00F0FF] mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-outfit font-medium text-white mb-1">{point.title}</h3>
                      <p className="text-sm text-neutral-500 font-manrope leading-relaxed">{point.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative hidden lg:block"
          >
            <div className="relative rounded-sm overflow-hidden border border-white/10">
              <img src={ABOUT_IMG} alt="wedowedo office" className="w-full h-[600px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
              <div className="absolute inset-0 shadow-[inset_0_0_80px_rgba(0,240,255,0.08)]" />
            </div>
            <div className="absolute -inset-1 bg-[#00F0FF]/5 rounded-sm blur-xl -z-10" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
